import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { 
  Handshake, Shield, Award, CheckCircle, ArrowRight, Phone,
  Building2, Users, Star
} from 'lucide-react';

// 24 Partenaires officiels du Cabinet CAMBC Conseils
const partners = [
  {
    name: 'Abeille Assurances',
    initials: 'Ab',
    brandColor: '#FFB800',
    textColor: '#000000',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/n6eum50m_abeille%20assurance.png',
    description: 'Assureur généraliste issu du groupe Aviva France',
    specialties: ['Auto', 'Habitation', 'Santé', 'Épargne']
  },
  {
    name: 'Allianz',
    initials: 'Az',
    brandColor: '#003781',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/7q0nwn8y_Allianz-logo.webp',
    description: 'Leader mondial de l\'assurance et de la gestion d\'actifs',
    specialties: ['Auto', 'Habitation', 'Santé', 'Vie']
  },
  {
    name: 'AXA',
    initials: 'AXA',
    brandColor: '#00008F',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/0rzpr2cm_axa.png',
    description: 'Protection et services d\'assurance innovants',
    specialties: ['Auto', 'Habitation', 'Pro', 'Santé']
  },
  {
    name: 'CMAM',
    initials: 'CMAM',
    brandColor: '#1B4F72',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/909ofzjq_CMAM.png',
    description: 'Courtage et mutualité au service des assurés',
    specialties: ['Auto', 'Habitation', 'Pro']
  },
  {
    name: 'Solly Azar',
    initials: 'SA',
    brandColor: '#1E3A8A',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/dm1ddpkn_SOLLY-AZAR.png',
    description: 'Courtier grossiste spécialiste des risques non-standards',
    specialties: ['Auto', 'Temporaire', 'Résiliés', 'Moto']
  },
  {
    name: 'Spring Assur',
    initials: 'Sp',
    brandColor: '#10B981',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/uvcih1ca_spring%20assur.webp',
    description: 'Assurance digitale nouvelle génération',
    specialties: ['Auto', 'Habitation', '2 Roues']
  },
  {
    name: 'Leocare',
    initials: 'Leo',
    brandColor: '#6366F1',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/0g88g23x_images%20%281%29.png',
    description: 'Assurance connectée et personnalisée',
    specialties: ['Auto', 'Habitation', 'Objets connectés']
  },
  {
    name: 'Apivia par Macif',
    initials: 'Api',
    brandColor: '#1e40af',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/cys39s3x_Apivia_parMacif_1024_1024_couleur.png',
    description: 'Mutuelle santé et prévoyance du groupe MACIF',
    specialties: ['Santé', 'Prévoyance', 'Dentaire', 'Optique']
  },
  {
    name: 'JL Assure',
    initials: 'JL',
    brandColor: '#DC2626',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/cdtvq0rm_jl%20assure.png',
    description: 'Courtier grossiste multi-produits',
    specialties: ['Auto', 'Habitation', 'Temporaire']
  },
  {
    name: 'Plus Simple',
    initials: 'P+',
    brandColor: '#F97316',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/szfuq88u_%2B%20simple.png',
    description: 'L\'assurance simplifiée pour tous',
    specialties: ['Auto', 'Habitation', 'Santé']
  },
  {
    name: 'Orus',
    initials: 'Or',
    brandColor: '#7C3AED',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/n20cru1p_orus.png',
    description: 'Assurance professionnelle digitale',
    specialties: ['RC Pro', 'Décennale', 'Entreprises']
  },
  {
    name: 'Teris Assurance',
    initials: 'Te',
    brandColor: '#0891B2',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/ni6c6uo9_teris%20assurance.png',
    description: 'Solutions d\'assurance sur mesure',
    specialties: ['Auto', 'Habitation', 'Pro']
  },
  {
    name: 'Assurmax',
    initials: 'Ax',
    brandColor: '#BE185D',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/6a3oe18v_assurmax.png',
    description: 'Maximisez votre protection',
    specialties: ['Auto', 'Habitation', '2 Roues']
  },
  {
    name: 'Alliass',
    initials: 'As',
    brandColor: '#4338CA',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/fix3bdb1_alliass.png',
    description: 'Partenaire des courtiers indépendants',
    specialties: ['Auto', 'Habitation', 'Pro']
  },
  {
    name: 'Tutassûr',
    initials: 'Tu',
    brandColor: '#7C3AED',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/z5z2n0n0_tutassur.webp',
    description: 'Votre assurance en toute confiance',
    specialties: ['Auto', 'Habitation', 'Santé']
  },
  {
    name: 'April',
    initials: 'Apr',
    brandColor: '#E94E1B',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/xmfpjqfm_April.png',
    description: 'Grossiste en assurance et services innovants',
    specialties: ['Santé', 'Temporaire', 'Voyage', 'Expatriés']
  },
  {
    name: 'Zephir',
    initials: 'Ze',
    brandColor: '#0EA5E9',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/oev90tp5_zephir.png',
    description: 'Un souffle nouveau dans l\'assurance',
    specialties: ['Auto', 'Habitation', 'Santé']
  },
  {
    name: 'Optineo',
    initials: 'Op',
    brandColor: '#8B5CF6',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/z8sum90e_optineo.png',
    description: 'L\'assurance optimisée pour vous',
    specialties: ['Auto', 'Habitation', 'Pro']
  },
  {
    name: 'Oyat',
    initials: 'Oy',
    brandColor: '#84CC16',
    textColor: '#000000',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/uuaw8d3p_Oyat-logo.png',
    description: 'Solutions d\'assurance flexibles',
    specialties: ['Auto', 'Habitation', '2 Roues']
  },
  {
    name: 'Luxior',
    initials: 'Lx',
    brandColor: '#B8860B',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/exw2kogw_luxior-assurances.jpg',
    description: 'L\'excellence en assurance',
    specialties: ['Auto', 'Habitation', 'Haut de gamme']
  },
  {
    name: 'FMA Assurances',
    initials: 'FMA',
    brandColor: '#1D4ED8',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/sh96b16q_fma.png',
    description: 'Fédération des Mutuelles d\'Assurance',
    specialties: ['Auto', 'Habitation', 'Santé']
  },
  {
    name: 'Mascotte',
    initials: 'Ma',
    brandColor: '#DB2777',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/d8mn0f0x_mascotte%20assurance.png',
    description: 'L\'assurance qui vous accompagne',
    specialties: ['Auto', 'Habitation', 'Animaux']
  },
  {
    name: 'Entoria',
    initials: 'En',
    brandColor: '#E91E8C',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_6425a001-6005-4980-aec0-fb0012ba138e/artifacts/qauyxybh_792feb65-9141-4b6b-8502-6fa7e46bc5f7.png',
    description: 'Assurance santé collective et individuelle',
    specialties: ['Santé', 'Prévoyance', 'Retraite']
  },
  {
    name: 'Matrisk',
    initials: 'Mk',
    brandColor: '#374151',
    description: 'Expert en gestion des risques',
    specialties: ['Pro', 'RC', 'Décennale', 'Entreprises']
  }
];

const advantages = [
  {
    icon: Shield,
    title: 'Sélection Rigoureuse',
    description: 'Nous travaillons uniquement avec des compagnies reconnues pour leur solidité financière et leur qualité de service.'
  },
  {
    icon: Award,
    title: 'Meilleurs Tarifs',
    description: 'Notre multi-représentation nous permet de négocier les tarifs les plus compétitifs pour nos clients.'
  },
  {
    icon: Users,
    title: 'Service Personnalisé',
    description: 'Un interlocuteur unique qui connaît votre dossier et vous accompagne dans toutes vos démarches.'
  },
  {
    icon: Star,
    title: 'Expertise Métier',
    description: 'Plus de 15 ans d\'expérience dans le courtage d\'assurance à votre service.'
  }
];

// Styled Logo Component
const PartnerLogo = ({ initials, brandColor, textColor = '#FFFFFF', name, logo }) => {
  if (logo) {
    // Display actual logo image
    return (
      <div 
        className="w-full h-14 rounded-xl flex items-center justify-center bg-white shadow-sm transition-transform duration-300 group-hover:scale-105 p-2"
        title={name}
      >
        <img 
          src={logo} 
          alt={`Logo ${name}`}
          className="max-h-full max-w-full object-contain"
          loading="lazy"
        />
      </div>
    );
  }
  
  // Fallback to CSS initials
  return (
    <div 
      className="w-full h-14 rounded-xl flex items-center justify-center font-bold text-lg tracking-tight shadow-sm transition-transform duration-300 group-hover:scale-105"
      style={{ 
        backgroundColor: brandColor,
        color: textColor
      }}
      title={name}
    >
      {initials}
    </div>
  );
};

export const Partners = () => {
  return (
    <>
      <Helmet>
        <title>Nos Partenaires Assureurs | Cabinet CAMBC Conseils Moissac</title>
        <meta name="description" content="Découvrez nos 24 partenaires assureurs : Allianz, AXA, Abeille, April, Solly Azar et plus. Courtier multi-compagnies à Moissac (82)." />
        <meta name="keywords" content="partenaires assurance, compagnies assurance, Allianz, AXA, Abeille, April, courtier Moissac" />
        <link rel="canonical" href="https://www.cambc-conseils.fr/partenaires" />
      </Helmet>

      <div className="min-h-screen bg-[#F9F8F6]">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-[#0F2137] overflow-hidden">
          <div className="absolute inset-0 opacity-[0.03]" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}></div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#C5A059]/20 rounded-full text-[#C5A059] text-sm font-medium mb-6">
                <Handshake size={16} />
                <span>Réseau de confiance</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
                Nos partenaires
                <span className="block text-[#C5A059]">assureurs</span>
              </h1>
              <p className="text-lg sm:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
                En tant que courtier indépendant, nous collaborons avec <span className="text-[#C5A059] font-semibold">24 compagnies partenaires</span> pour 
                vous proposer les meilleures solutions d'assurance.
              </p>
            </div>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#C5A059] to-transparent"></div>
        </section>

        {/* Advantages Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {advantages.map((advantage, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-[#F5EFE6] flex items-center justify-center">
                    <advantage.icon size={28} className="text-[#C5A059]" />
                  </div>
                  <h3 className="text-lg font-bold text-[#0F2137] mb-2">{advantage.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{advantage.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Partners Grid */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#0F2137] mb-4">
                24 compagnies partenaires
              </h2>
              <p className="text-slate-600 max-w-2xl mx-auto">
                Une sélection de compagnies d'assurance de premier plan pour répondre à tous vos besoins
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
              {partners.map((partner, index) => (
                <Card 
                  key={index}
                  className="bg-white border-0 shadow-sm hover:shadow-lg transition-all duration-300 rounded-xl overflow-hidden group"
                >
                  <CardContent className="p-4">
                    {/* Styled Logo */}
                    <div className="mb-3">
                      <PartnerLogo 
                        initials={partner.initials}
                        brandColor={partner.brandColor}
                        textColor={partner.textColor}
                        name={partner.name}
                        logo={partner.logo}
                      />
                    </div>

                    {/* Name */}
                    <h3 className="text-sm font-bold text-[#0F2137] text-center truncate" title={partner.name}>
                      {partner.name}
                    </h3>

                    {/* Specialties - compact */}
                    <div className="flex flex-wrap gap-1 justify-center mt-2">
                      {partner.specialties.slice(0, 2).map((specialty, idx) => (
                        <span 
                          key={idx}
                          className="px-1.5 py-0.5 bg-[#F5EFE6] text-[#0F2137] text-[10px] font-medium rounded"
                        >
                          {specialty}
                        </span>
                      ))}
                      {partner.specialties.length > 2 && (
                        <span className="px-1.5 py-0.5 bg-slate-100 text-slate-500 text-[10px] font-medium rounded">
                          +{partner.specialties.length - 2}
                        </span>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-[#0F2137]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid sm:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-4xl sm:text-5xl font-bold text-[#C5A059] mb-2">24</div>
                <div className="text-slate-300">Compagnies partenaires</div>
              </div>
              <div>
                <div className="text-4xl sm:text-5xl font-bold text-[#C5A059] mb-2">15</div>
                <div className="text-slate-300">Années d'expérience</div>
              </div>
              <div>
                <div className="text-4xl sm:text-5xl font-bold text-[#C5A059] mb-2">100%</div>
                <div className="text-slate-300">Indépendant</div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F5EFE6] rounded-full text-[#C5A059] text-sm font-medium mb-6">
              <Building2 size={16} />
              <span>Courtier indépendant</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0F2137] mb-6">
              Trouvons ensemble la meilleure offre
            </h2>
            <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
              En tant que courtier, nous comparons pour vous les offres de nos 24 compagnies 
              partenaires pour vous proposer la couverture la plus adaptée au meilleur prix.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/quote">
                <Button size="lg" className="bg-[#C5A059] hover:bg-[#B08A45] text-white font-semibold px-8 py-6 rounded-xl">
                  Demander un devis gratuit
                  <ArrowRight size={18} className="ml-2" />
                </Button>
              </Link>
              <a href="tel:0582819120">
                <Button size="lg" variant="outline" className="border-2 border-[#0F2137] text-[#0F2137] hover:bg-[#0F2137] hover:text-white px-8 py-6 rounded-xl">
                  <Phone size={18} className="mr-2" />
                  05 82 81 91 20
                </Button>
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
